import { Drawer } from 'almanac-ui/Drawer/Drawer'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { useEffect } from 'react'
import { PlagiarismDetectionPanel } from './Panels/PlagiarismDetectionPanel/PlagiarismDetectionPanel'
import { SEOAnalysisPanel } from './Panels/SEOAnalysisPanel/SEOAnalysisPanel'
import { ReviewSubmissionPanel } from './Panels/ReviewSubmissionPanel/ReviewSubmissionPanel'
import { useCurrentArticleMeta } from 'hooks/useCurrentArticleMeta'
import { BlogMetadataPanel } from './Panels/BlogMetadataPanel/BlogMetadataPanel'

export const DocRightPanelWrapper = observer(() => {
  const rightRailPanelStore = useRootStore().rightRailPanelStore
  const article = useCurrentArticleMeta()
  const { docStore } = useRootStore()

  const articleId = docStore?.articleId

  useEffect(() => {
    rightRailPanelStore.hideImmediately()
  }, [articleId, rightRailPanelStore])

  return (
    <Drawer
      open={rightRailPanelStore.shown && !!rightRailPanelStore.openedDrawer}
      onClose={() => rightRailPanelStore.hide()}
      styles={{
        width: !!article ? 324 : 312,
        top: article?.current_user_access === 'comment' ? 72 : 60,
        offset: 10,
        borderRadius: 10,
        backgroundColor: rightRailPanelStore.openedDrawer === 'review_submission' ? 'var(--light-60)' : undefined,
      }}
      animated={rightRailPanelStore.animated}
    >
      {rightRailPanelStore.openedDrawer === 'plagiarism' && <PlagiarismDetectionPanel />}
      {rightRailPanelStore.openedDrawer === 'seo' && <SEOAnalysisPanel />}
      {rightRailPanelStore.openedDrawer === 'review_submission' && <ReviewSubmissionPanel />}
      {rightRailPanelStore.openedDrawer === 'blog_metadata' && <BlogMetadataPanel articleId={articleId ?? ''} />}
    </Drawer>
  )
})
